// extracted by mini-css-extract-plugin
module.exports = {"modal":"BrandEditor_modal__2klOO","buttons":"BrandEditor_buttons__1nQAO"};